export default __webpack_public_path__ + "static/music-bg-8856b78e7cd2a52f0db280888e2f6796.jpg";